/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders. All files are confidential
 * and only available to authorized individuals with the permission of the
 * copyright holders. If you encounter any file and do not have permission,
 * please get in touch with the copyright holders and delete this file.
 *
 * Uses CryptoJS passphrase mode (EVP_BytesToKey) - compatible with OpenSSL:
 *   openssl enc -aes-256-cbc -e -a -pass pass:PASSPHRASE
 */
import CryptoJS from "crypto-js";

import warning from "./warning";

/**
 * Encrypts plaintext using AES-256-CBC with passphrase (EVP_BytesToKey).
 * Output is OpenSSL-compatible "Salted__" base64 format - single line, safe for URL params.
 */
export const encrypt = (plaintext: string): string => {
  try {
    const encrypted = CryptoJS.AES.encrypt(plaintext, PASSPHRASE);
    return encrypted.toString().replace(/\s/g, "");
  } catch (e) {
    warning(e);
    return "";
  }
};

/**
 * Encrypts a payload object as JSON (OpenSSL-compatible format).
 */
const PASSPHRASE = "blinkchatbot2025!";

/**
 * Decrypts ciphertext encrypted with encrypt (passphrase mode).
 * Normalizes for URL query params: space→+, percent-decode, strip whitespace.
 */
export const decrypt = (ciphertext: string): string => {
  try {
    let normalized = ciphertext.replace(/ /g, "+");
    try {
      normalized = decodeURIComponent(normalized);
    } catch {
      // Invalid percent-encoding; use as-is
    }
    normalized = normalized.replace(/\s/g, "");

    const decrypted = CryptoJS.AES.decrypt(normalized, PASSPHRASE);
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (e) {
    warning(e);
    return "";
  }
};
